import { PropertyCard } from '@zillow/constellation-10';
import { css } from '@/styled-system/css';

const skeletonSection = css({
  flex: 1,
  paddingInline: { base: 'default', md: 0 },
  paddingBottom: { base: 'default', md: 0 },
  paddingTop: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
});

// Mirror LiveListingsGrid's container-query threshold so the skeleton's
// column count matches the rendered grid at every panel width.
const SRP_TWO_COL_MIN = '36em';

const skeletonGrid = css({
  display: 'grid',
  gridTemplateColumns: '1fr',
  [`@container srpContentPanel (min-width: ${SRP_TWO_COL_MIN})`]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  gap: '400',
  marginBottom: '400',
  listStyle: 'none',
  padding: 0,
  margin: 0,
});

type ListingsSkeletonProps = {
  ariaLabel: string;
};

export function ListingsSkeleton({ ariaLabel }: ListingsSkeletonProps) {
  return (
    <div
      id="srp-listings-skeleton"
      data-srp-component="listings-skeleton"
      className={skeletonSection}
      aria-busy="true"
      aria-live="polite"
    >
      <ul role="list" aria-label={ariaLabel} className={skeletonGrid}>
        {Array.from({ length: 6 }).map((_, i) => (
          <li key={i} aria-hidden="true">
            <PropertyCard appearance="large" loading />
          </li>
        ))}
      </ul>
    </div>
  );
}
